<template>
  <div>
    <div class="d-flex justify-content-between my-3">
        <label class="align-self-center w-50 text-right"> Credit Line </label>
        <div :class="contractBrand && contractBrand.name != null ? 'text-right' : 'text-center'" style="min-width: 100px;">
          <span v-if="contractBrand && contractBrand.name != null"> {{ contractBrand.name }} </span>
        </div>
    </div>
    <div v-if="contractBrand && contractBrand.credit" class="d-flex justify-content-between my-3">
        <label class="align-self-center w-50 text-right"> Available Credit </label>
        <div :class="contractBrand && contractBrand.credit != null ? 'text-right' : 'text-center'" style="min-width: 100px;">
          <span v-if="contractBrand && contractBrand.credit != null"> £{{ contractBrand.credit | priceformat }} </span>
          <span v-else> - </span>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    contractBrand: {
      type: Object,
      required: true,
    }
  }
}
</script>